<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 14:59:11
 * @LastEditors: smallWhite
 * @LastEditTime: 2022-12-20 11:03:12
 * @FilePath: /fujian-official-website/src/views/news/components/company_news.vue
-->
<template>
  <div class="news_contents" style="padding-top:10px">
      <img v-if="loading" src="../../../assets/imgaes/loading.7.gif" style="height:300px;margin: 0 auto;display: block;">
    <div v-else class="news_contents_a">
      <div class="news_items">
        <div class="news_first">
          <div class="news_img">
            <img :src="newFirstObj.imgUrl" >
          </div>
          <div class="news_content">
            <div class="news_title">{{newFirstObj.title}}</div>
            <div class="news_times">
              <i class="el-icon-date"></i>
              <span>{{newFirstObj.times}}</span>
            </div>
            <div class="news_body">
              <p>{{newFirstObj.introduction}}</p>
            </div>
            <span @click="gotoDetails(newFirstObj)" class="news_btn_span">查看详情>></span>
          </div>
        </div>
      </div>
      <div class="news_items" v-for="(item,index) in newsList" :key="index">
        <div class="news_more" @click="gotoDetails(item)">
          <el-row :gutter="20">
            <el-col :md="6" :lg="6">
              <div style="margin-top: 20px; height: 160px;">
                <img :src="item.imgUrl" style="width:100%;height:100%">
              </div>
            </el-col>
            <el-col :md="15" :lg="15">
              <div class="items_content">
                <div class="items_title">{{item.title}}</div>
                <div class="items_body">
                  <div class="items_body_content">
                    <p>{{item.introduction}}</p>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :md="3" :lg="3">
              <div class="items_date">
                <div class="items_date_div">
                  <div style="margin: 16px 0px;">
                    <i class="el-icon-date" style="font-size:20px"></i>
                  </div>
                  <span>{{item.time.substring(0,10)}}</span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-pagination
      style="margin-top: 20px; text-align: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      loading:true,
      newFirstObj:{},
      newsList:[],
      pageNum:1,
      pageSize:10,
      total:0
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      this.loading = true
      axios.post('/home/news', { 
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 2
      }).then((res) => {
        this.loading = false
        this.total = parseInt(res.data.data.total)  
        const newsList = res.data.data.newsList
        newsList.map(item=>{
          this.$set(item,'imgUrl',res.data.data.imgUrl +'/'+ item.url)
        })
        this.newsList = newsList.slice(1,newsList.length)
        const firstArr = newsList.slice(0,1)
        this.newFirstObj = firstArr[0]
        this.newFirstObj.times = firstArr[0].time.substring(0,10)
        this.goTop()
      })
    },
    gotoDetails(item){
      this.$router.push({
        path:'/news_details',
        query:{
          id:item.id
        }
      })
    },
    handleSizeChange(val) {
        this.pageSize = val
        this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    goTop() {
      var timer = null
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
  }
}
</script>

<style>

</style>